import React from "react";
import SidePanel from "../../components/SidePanel";

const Help = () => {
  return (
    <section className="flex">
      <SidePanel />
      <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
        <h1 className="text-4xl text-gray-500 font-bold sm:text-left text-center mb-5">
          Help
        </h1>
      </div>
    </section>
  );
};

export default Help;
